module.exports = __webpack_public_path__ + "img/ico-check-white-de.6aff5a5e.svg";